import * as React from "react";
import { match } from "react-router";
import { Link } from "react-router-dom";

import * as Poems from "../Data/Poems";
import { getClassNames, PoemPageClassNames } from "./PoemPage.styles";

const poems = Poems.poems.reverse();

export function PoemPage(props: PoemPageProps): JSX.Element {
    const classNames: PoemPageClassNames = getClassNames();
    const content: React.ReactNode = props.match.params.name
        ? Poem(classNames.date, props.match.params.name)
        : PoemList(props.match.url);
    return <div className={classNames.root}>{content}</div>;
}

function Poem(dateClassName: string, name: string): React.ReactNode {
    for (const poem of poems) {
        const decodedName: string = decodeURIComponent(name);
        if (poem.name === decodedName) {
            return (
                <div>
                    <div>
                        <h1>
                            {poem.name}
                            <sub className={dateClassName}>
                                {poem.date.toDateString()}
                            </sub>
                        </h1>
                    </div>
                    {poem.poem}
                </div>
            );
        }
    }

    return <div>that poem doesn't exist dummy!</div>;
}

function PoemList(url: string): React.ReactNode {
    return (
        <div>
            <h1>poems:</h1>
            {poems.map(poem => {
                return (
                    <div key={poem.name}>
                        <Link to={`${url}/${poem.name}`}>{poem.name}</Link>
                    </div>
                );
            })}
        </div>
    );
}

interface PoemPageParams {
    name?: string;
}

interface PoemPageProps {
    match: match<PoemPageParams>;
}

if (new Set(poems.map(poem => poem.name)).size !== poems.length) {
    throw new Error(
        "Two poems have the same name! (I should be doing this in test, but when am I going to run that?)"
    );
}
